/* eslint-disable react-hooks/exhaustive-deps */
import dayjs from "dayjs";
import utc from "dayjs-plugin-utc";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

import { Pagination } from "../../components/Pagination";
import { TableConfig } from "../../config/Config";
import { useNotification } from "../../context/notification";
import { apiRequest } from "../../utils/api";

import { useTranslation } from "react-i18next";
import styles from "./WarningLetters.module.scss";

const defaultTableHeader = [
  { name: "date_issued", label: "Date Issued", width: "16%" },
  { name: "name", label: "Name", width: "25%" },
  { name: "subject", label: "Subject", width: "10%" },
  { name: "failed_subject", label: "Failed", width: "7%" },
  { name: "verbal_warning", label: "Verbal Warning", width: "7%" },
  { name: "reported_by", label: "Reported By", width: "15%" },
  { name: "campaign_name", label: "Functional Unit", width: "15%" },
];

function Row({ row }) {
  const history = useHistory();
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow
        className={`${styles.tableRow} ${open ? styles.openRow : ""}`}
        onClick={() => {
          history.push(
            `/warningLetters/session/${row.session_id}:${row.subject_id}`
          );
        }}
      >
        <TableCell
          component="th"
          scope="row"
          className={`${open ? styles.openRow : ""}`}
        >
          {row.date_issued && row.date_issued !== null && dayjs && (
            <span>
              {dayjs(row.date_issued)
                .add(dayjs().utcOffset(), "minutes")
                .format("DD MMM YYYY")}
            </span>
          )}
        </TableCell>
        <TableCell className={`${open ? styles.openRow : ""}`}>
          {row.name}
        </TableCell>
        <TableCell className={`${open ? styles.openRow : ""}`}>
          {" "}
          {row.subject}
          {"  - "}
          {row.sub_subject}
        </TableCell>
        <TableCell className={`${open ? styles.openRow : ""}`}>
          {row.failed_subject}
        </TableCell>
        <TableCell className={`${open ? styles.openRow : ""}`}>
          {" "}
          {row.verbal_warning}{" "}
        </TableCell>
        <TableCell className={`${open ? styles.openRow : ""}`}>
          {" "}
          {row.reported_by}{" "}
        </TableCell>
        <TableCell className={`${open ? styles.openRow : ""}`}>
          {" "}
          {row.campaign_name}{" "}
        </TableCell>
        <TableCell className={`${open ? styles.openRow : ""}`}>
          <IconButton
            aria-label="expand row"
            size="small"
            style={{ outline: "none" }}
            onClick={e => {
              e.stopPropagation();
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow className={styles.tableDetailsRow}>
        <TableCell
          style={{
            padding: "0",
            borderBottomWidth: open ? "1px" : 0,
          }}
          colSpan={9}
        >
          <Collapse
            in={open}
            timeout="auto"
            style={{
              padding: "16px",
              overflow: "hidden",
              marginTop: "-22px",
            }}
            unmountOnExit
          >
            <Table size="small" aria-label="purchases">
              <TableBody>
                <RowDetails rowDetails={row.warning_issued_date} />
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

function RowDetails({ rowDetails }) {
  return (
    <>
      {rowDetails &&
        rowDetails.map((sub, index) => (
          <TableRow className={styles.tableDetailsRow} key={index}>
            <TableCell
              className={`${styles.tableDetailsColumn} ${styles.lineIndication}`}
              style={{ width: "15%" }}
            >
              <FiberManualRecordIcon className={styles.nonCompleted} />
              {dayjs(sub.date)
                .add(dayjs().utcOffset(), "minutes")
                .format("DD MMM YYYY")}
            </TableCell>
            <TableCell
              className={styles.tableDetailsColumn}
              style={{ width: "30%" }}
            >
              {sub.msg}
            </TableCell>
            <TableCell className={styles.tableDetailsColumn} />
          </TableRow>
        ))}
    </>
  );
}

dayjs.extend(utc);
export function WarningLettersTable({
  filters,
  getDataFrom,
  uid,
  searchKey,
  tableHeader = defaultTableHeader,
  ...props
}) {
  const { t } = useTranslation();
  const history = useHistory();
  const { addNotification } = useNotification();
  const [warningLettersData, setWarningLettersData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [offset, setOffset] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [perPage] = useState(TableConfig.resultPerPage);
  const [columnName, setColumnName] = useState("date_issued");
  const [sortOrder, setSortOrder] = useState("asc");

  async function fetchData() {
    setIsLoading(true);

    let param = `?uid=${uid}&page=${offset}&limit=${perPage}${filters}&search=${searchKey ? searchKey : ""
      }&column_name=${columnName}&order=${sortOrder}`;

    const response = await apiRequest.get(`${getDataFrom}${param}`);

    if (response.status === 200) {
      const data = response.data;
      // const logList = data.data;
      setWarningLettersData(data.data);
      setTotalData(data.totalData);
    } else {
      addNotification(
        t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
        "error"
      );
    }
    setIsLoading(false);
  }
  useEffect(() => {
    setOffset(1);
  }, [searchKey]);

  useEffect(() => {
    fetchData();
  }, [offset, columnName, sortOrder, uid, getDataFrom, searchKey, filters]);

  const handlePaginationChange = offset => {
    setOffset(offset.selected + 1);
  };

  const sortData = name => {
    setColumnName(name);
    const order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
  };

  return (
    <>
      <TableContainer component={Paper} elevation={0}>
        <Table aria-label="Team" className={styles.table}>
          <TableHead className={styles.tableHead}>
            <TableRow>
              {tableHeader &&
                tableHeader.map((tableHead, index) => (
                  <TableCell
                    key={index}
                    style={{ width: tableHead.width }}
                    className={styles.tableHeadCell}
                    onClick={() => {
                      sortData(tableHead.name);
                    }}
                  >
                    {tableHead.label}

                    {columnName === tableHead.name && sortOrder === "asc" && (
                      <span>
                        <KeyboardArrowUpIcon fontSize="small" />
                      </span>
                    )}
                    {columnName === tableHead.name && sortOrder === "desc" && (
                      <span>
                        <KeyboardArrowDownIcon fontSize="small" />
                      </span>
                    )}
                  </TableCell>
                ))}
              <TableCell style={{ width: "5%" }}></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {warningLettersData &&
              warningLettersData.map((row, index) => (
                <>
                  <Row row={row} key={index} />
                </>
              ))}

            {_.isEmpty(warningLettersData) && (
              <TableRow>
                <TableCell colSpan={8}>No warning letters are found</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {totalData > perPage && (
        <Pagination
          totalData={totalData}
          limit={perPage}
          offset={offset}
          handlePageClick={offset => {
            handlePaginationChange(offset);
          }}
        />
      )}
    </>
  );
}
